var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _g, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchitecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 660,
    height: 448,
    viewBox: "0 0 660 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.465 37.8563C80.0031 87.3413 157.977 141.367 121.247 169.574C84.5213 197.784 -71.2629 258.298 95.3996 347.263C156.134 379.683 191.73 429.251 223.5 447H307.5C336.958 443.379 352.245 433.554 383.552 413.551C493.786 343.12 401.931 351.51 498.805 387.921C595.68 424.332 689.705 351.686 651.137 275.283C612.569 198.88 591.344 201.251 626.251 148.566C661.158 95.8813 583.872 -65.2955 459.442 50.6272C423.5 82 374.5 77.5 337.692 50.6272C305.628 22.3715 215.374 -40.3508 132.465 37.8563Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M334.744 341.629L324.942 429.467H438.662L423.85 341.629H334.744Z",
    fill: "#8495A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.363 127.228V346.437C123.363 364.47 137.745 379.215 155.786 379.681C235.918 381.744 513.112 386.751 589.391 385.629C602.501 385.437 613.122 374.952 613.5 361.856L611.585 131.618C609.723 119.647 599.611 110.694 587.49 110.306C520.35 108.162 223.256 101.346 147.012 103.058C133.863 103.354 123.363 114.087 123.363 127.228Z",
    fill: "#ABB5BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144 134V334.426C144 344.954 152.458 353.535 162.994 353.692L588 358.943C598.445 359.099 600.961 350.703 601 340.264C601 340.264 601 141 601 134C601 127 595 120 588 120H157C150 120 144 127 144 134Z",
    fill: "#181B32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158 144.632V327.875C158 333.875 162.801 338.764 168.778 338.848L249.733 339.999C255.732 340.084 260.68 335.296 260.816 329.273L264.997 143.224C265.137 136.982 260.073 131.882 253.856 132.002L168.719 133.661C162.766 133.775 158 138.654 158 144.632Z",
    fill: "#2C3553"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M276.337 145.066L275.332 330.717C275.299 336.754 280.15 341.682 286.191 341.75L575.466 344.996C581.569 345.065 586.56 340.146 586.573 334.048L587 147.253C587.013 141.214 582.14 136.299 576.096 136.253L287.398 134.151C281.327 134.105 276.369 138.997 276.337 145.066Z",
    fill: "#2C3553"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M463.159 447.438H296.724C292.203 447.438 288.807 444.221 289.681 440.767L291.818 432.328C292.46 429.789 295.256 427.928 298.573 427.824L459.023 422.821C462.49 422.713 465.56 424.552 466.317 427.188L470.166 440.63C471.164 444.124 467.752 447.438 463.159 447.438Z",
    fill: "#ABB5BA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M231.319 152.732H171.071C170.024 152.732 169.173 151.881 169.173 150.835V146.927C169.173 145.881 170.024 145.03 171.071 145.03H231.319C232.369 145.03 233.217 145.881 233.217 146.927V150.835C233.217 151.881 232.366 152.732 231.319 152.732Z",
    fill: "#FF8578"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M350.362 165.404H290.115C289.068 165.404 288.216 164.553 288.216 163.507V159.596C288.216 158.55 289.068 157.699 290.115 157.699H350.362C351.413 157.699 352.261 158.55 352.261 159.596V163.504C352.261 164.553 351.413 165.404 350.362 165.404Z",
    fill: "#FF8578"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M454.277 163.98H359.985C358.938 163.98 358.086 163.129 358.086 162.083V159.596C358.086 158.55 358.938 157.699 359.985 157.699H454.277C455.324 157.699 456.175 158.55 456.175 159.596V162.083C456.175 163.129 455.324 163.98 454.277 163.98Z",
    fill: "#606BF1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M501.865 165.404H485.079C484.032 165.404 483.18 164.553 483.18 163.507V159.596C483.18 158.55 484.032 157.699 485.079 157.699H501.865C502.912 157.699 503.763 158.55 503.763 159.596V163.504C503.763 164.553 502.912 165.404 501.865 165.404Z",
    fill: "#FBD15B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M570.612 165.404H511.787C510.74 165.404 509.889 164.553 509.889 163.507V159.596C509.889 158.55 510.74 157.699 511.787 157.699H570.612C571.659 157.699 572.511 158.55 572.511 159.596V163.504C572.511 164.553 571.663 165.404 570.612 165.404Z",
    fill: "#606BF1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M350.362 178.362H290.115C289.068 178.362 288.216 177.512 288.216 176.466V172.558C288.216 171.511 289.068 170.661 290.115 170.661H350.362C351.413 170.661 352.261 171.511 352.261 172.558V176.466C352.261 177.515 351.413 178.362 350.362 178.362Z",
    fill: "#FF8578"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M425.631 174.543H359.985C358.938 174.543 358.086 173.693 358.086 172.646V170.159C358.086 169.113 358.938 168.263 359.985 168.263H425.631C426.681 168.263 427.529 169.113 427.529 170.159V172.646C427.529 173.696 426.678 174.543 425.631 174.543Z",
    fill: "#606BF1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M440.257 174.543H432.177C431.13 174.543 430.278 173.693 430.278 172.646V170.159C430.278 169.113 431.13 168.263 432.177 168.263H440.257C441.307 168.263 442.155 169.113 442.155 170.159V172.646C442.155 173.696 441.304 174.543 440.257 174.543Z",
    fill: "#FBD15B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M507.99 178.362H467.455C466.408 178.362 465.556 177.512 465.556 176.466V172.558C465.556 171.511 466.408 170.661 467.455 170.661H507.99C509.041 170.661 509.889 171.511 509.889 172.558V176.466C509.889 177.515 509.041 178.362 507.99 178.362Z",
    fill: "#606BF1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M350.362 196.386H290.115C289.068 196.386 288.216 195.536 288.216 194.489V190.581C288.216 189.532 289.068 188.685 290.115 188.685H350.362C351.413 188.685 352.261 189.535 352.261 190.581V194.489C352.261 195.539 351.413 196.386 350.362 196.386Z",
    fill: "#FF8578"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M476.516 196.386H359.985C358.938 196.386 358.086 195.536 358.086 194.489V190.581C358.086 189.532 358.938 188.685 359.985 188.685H476.516C477.563 188.685 478.415 189.535 478.415 190.581V194.489C478.415 195.539 477.567 196.386 476.516 196.386Z",
    fill: "#606BF1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M570.612 196.386H511.787C510.74 196.386 509.889 195.536 509.889 194.489V190.581C509.889 189.532 510.74 188.685 511.787 188.685H570.612C571.659 188.685 572.511 189.535 572.511 190.581V194.489C572.511 195.539 571.663 196.386 570.612 196.386Z",
    fill: "#606BF1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M350.362 209.348H290.115C289.068 209.348 288.216 208.498 288.216 207.451V203.544C288.216 202.497 289.068 201.647 290.115 201.647H350.362C351.413 201.647 352.261 202.497 352.261 203.544V207.451C352.261 208.498 351.413 209.348 350.362 209.348Z",
    fill: "#FF8578"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M441.376 209.348H359.985C358.938 209.348 358.086 208.498 358.086 207.451V203.544C358.086 202.497 358.938 201.647 359.985 201.647H441.376C442.426 201.647 443.274 202.497 443.274 203.544V207.451C443.274 208.498 442.423 209.348 441.376 209.348Z",
    fill: "#606BF1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M459.32 209.348H448.545C447.495 209.348 446.647 208.498 446.647 207.451V203.544C446.647 202.497 447.498 201.647 448.545 201.647H459.32C460.367 201.647 461.218 202.497 461.218 203.544V207.451C461.218 208.498 460.367 209.348 459.32 209.348Z",
    fill: "#FBD15B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M507.99 209.348H467.455C466.408 209.348 465.556 208.498 465.556 207.451V203.544C465.556 202.497 466.408 201.647 467.455 201.647H507.99C509.041 201.647 509.889 202.497 509.889 203.544V207.451C509.889 208.498 509.041 209.348 507.99 209.348Z",
    fill: "#606BF1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M350.362 223.106H290.115C289.068 223.106 288.216 222.255 288.216 221.209V217.301C288.216 216.252 289.068 215.404 290.115 215.404H350.362C351.413 215.404 352.261 216.255 352.261 217.301V221.209C352.261 222.258 351.413 223.106 350.362 223.106Z",
    fill: "#FF8578"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M409.974 223.106H359.985C358.938 223.106 358.086 222.255 358.086 221.209V217.301C358.086 216.252 358.938 215.404 359.985 215.404H409.974C411.021 215.404 411.872 216.255 411.872 217.301V221.209C411.872 222.258 411.021 223.106 409.974 223.106Z",
    fill: "#606BF1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M421.302 223.106H415.9C414.85 223.106 414.002 222.255 414.002 221.209V217.301C414.002 216.252 414.853 215.404 415.9 215.404H421.302C422.352 215.404 423.2 216.255 423.2 217.301V221.209C423.2 222.258 422.352 223.106 421.302 223.106Z",
    fill: "#FBD15B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M452.032 223.106H427.839C426.792 223.106 425.94 222.255 425.94 221.209V217.301C425.94 216.252 426.792 215.404 427.839 215.404H452.032C453.083 215.404 453.931 216.255 453.931 217.301V221.209C453.931 222.258 453.083 223.106 452.032 223.106Z",
    fill: "#606BF1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M350.362 245.194H290.115C289.068 245.194 288.216 244.344 288.216 243.297V239.389C288.216 238.34 289.068 237.493 290.115 237.493H350.362C351.409 237.493 352.261 238.343 352.261 239.389V243.297C352.261 244.347 351.413 245.194 350.362 245.194Z",
    fill: "#FF8578"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M476.516 245.194H359.985C358.938 245.194 358.086 244.344 358.086 243.297V239.389C358.086 238.34 358.938 237.493 359.985 237.493H476.516C477.563 237.493 478.415 238.343 478.415 239.389V243.297C478.415 244.347 477.567 245.194 476.516 245.194Z",
    fill: "#606BF1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M501.865 245.194H485.079C484.032 245.194 483.18 244.344 483.18 243.297V239.389C483.18 238.34 484.032 237.493 485.079 237.493H501.865C502.915 237.493 503.763 238.343 503.763 239.389V243.297C503.763 244.347 502.912 245.194 501.865 245.194Z",
    fill: "#FBD15B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M570.612 245.194H511.787C510.74 245.194 509.889 244.344 509.889 243.297V239.389C509.889 238.34 510.74 237.493 511.787 237.493H570.612C571.659 237.493 572.511 238.343 572.511 239.389V243.297C572.511 244.347 571.663 245.194 570.612 245.194Z",
    fill: "#606BF1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M350.362 258.156H290.115C289.068 258.156 288.216 257.305 288.216 256.259V252.351C288.216 251.302 289.068 250.454 290.115 250.454H350.362C351.413 250.454 352.261 251.305 352.261 252.351V256.259C352.261 257.305 351.413 258.156 350.362 258.156Z",
    fill: "#FF8578"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M441.376 258.156H359.985C358.938 258.156 358.086 257.305 358.086 256.259V252.351C358.086 251.302 358.938 250.454 359.985 250.454H441.376C442.426 250.454 443.274 251.305 443.274 252.351V256.259C443.274 257.305 442.423 258.156 441.376 258.156Z",
    fill: "#606BF1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M459.32 258.156H448.545C447.495 258.156 446.647 257.305 446.647 256.259V252.351C446.647 251.302 447.498 250.454 448.545 250.454H459.32C460.367 250.454 461.218 251.305 461.218 252.351V256.259C461.218 257.305 460.367 258.156 459.32 258.156Z",
    fill: "#FBD15B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M507.99 258.156H467.455C466.408 258.156 465.556 257.305 465.556 256.259V252.351C465.556 251.302 466.408 250.454 467.455 250.454H507.99C509.041 250.454 509.889 251.305 509.889 252.351V256.259C509.889 257.305 509.041 258.156 507.99 258.156Z",
    fill: "#606BF1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M350.362 276.18H290.115C289.068 276.18 288.216 275.329 288.216 274.283V270.375C288.216 269.325 289.068 268.478 290.115 268.478H350.362C351.413 268.478 352.261 269.329 352.261 270.375V274.283C352.261 275.329 351.413 276.18 350.362 276.18Z",
    fill: "#FF8578"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M476.516 276.18H359.985C358.938 276.18 358.086 275.329 358.086 274.283V270.375C358.086 269.325 358.938 268.478 359.985 268.478H476.516C477.563 268.478 478.415 269.329 478.415 270.375V274.283C478.415 275.329 477.567 276.18 476.516 276.18Z",
    fill: "#606BF1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M501.865 276.18H485.079C484.032 276.18 483.18 275.329 483.18 274.283V270.375C483.18 269.325 484.032 268.478 485.079 268.478H501.865C502.912 268.478 503.763 269.329 503.763 270.375V274.283C503.763 275.329 502.912 276.18 501.865 276.18Z",
    fill: "#FBD15B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M570.612 276.18H511.787C510.74 276.18 509.889 275.329 509.889 274.283V270.375C509.889 269.325 510.74 268.478 511.787 268.478H570.612C571.659 268.478 572.511 269.329 572.511 270.375V274.283C572.511 275.329 571.663 276.18 570.612 276.18Z",
    fill: "#606BF1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M350.362 289.138H290.115C289.068 289.138 288.216 288.288 288.216 287.242V283.334C288.216 282.284 289.068 281.437 290.115 281.437H350.362C351.413 281.437 352.261 282.288 352.261 283.334V287.242C352.261 288.291 351.413 289.138 350.362 289.138Z",
    fill: "#FF8578"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M441.376 289.138H359.985C358.938 289.138 358.086 288.288 358.086 287.242V283.334C358.086 282.284 358.938 281.437 359.985 281.437H441.376C442.426 281.437 443.274 282.288 443.274 283.334V287.242C443.274 288.291 442.423 289.138 441.376 289.138Z",
    fill: "#606BF1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M459.32 289.138H448.545C447.495 289.138 446.647 288.288 446.647 287.242V283.334C446.647 282.284 447.498 281.437 448.545 281.437H459.32C460.367 281.437 461.218 282.288 461.218 283.334V287.242C461.218 288.291 460.367 289.138 459.32 289.138Z",
    fill: "#FBD15B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M507.99 289.138H467.455C466.408 289.138 465.556 288.288 465.556 287.242V283.334C465.556 282.284 466.408 281.437 467.455 281.437H507.99C509.037 281.437 509.889 282.288 509.889 283.334V287.242C509.889 288.291 509.041 289.138 507.99 289.138Z",
    fill: "#606BF1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M350.362 302.899H290.115C289.068 302.899 288.216 302.049 288.216 301.003V297.095C288.216 296.048 289.068 295.198 290.115 295.198H350.362C351.409 295.198 352.261 296.048 352.261 297.095V301.003C352.261 302.049 351.413 302.899 350.362 302.899Z",
    fill: "#FF8578"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M409.974 302.899H359.985C358.938 302.899 358.086 302.049 358.086 301.003V297.095C358.086 296.048 358.938 295.198 359.985 295.198H409.974C411.021 295.198 411.872 296.048 411.872 297.095V301.003C411.872 302.049 411.021 302.899 409.974 302.899Z",
    fill: "#606BF1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M421.302 302.899H415.9C414.85 302.899 414.002 302.049 414.002 301.003V297.095C414.002 296.048 414.853 295.198 415.9 295.198H421.302C422.349 295.198 423.201 296.048 423.201 297.095V301.003C423.201 302.049 422.352 302.899 421.302 302.899Z",
    fill: "#FBD15B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M255.265 167.161H178.31C177.26 167.161 176.411 166.31 176.411 165.264V159.277C176.411 158.23 177.263 157.38 178.31 157.38H255.265C256.315 157.38 257.163 158.23 257.163 159.277V165.264C257.163 166.313 256.315 167.161 255.265 167.161Z",
    fill: "#FF8578"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M230.484 178.907H189.723C188.216 178.907 186.993 177.685 186.993 176.179C186.993 174.673 188.216 173.451 189.723 173.451H230.484C231.991 173.451 233.214 174.673 233.214 176.179C233.217 177.685 231.994 178.907 230.484 178.907Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M230.484 188.623H189.723C188.216 188.623 186.993 187.401 186.993 185.895C186.993 184.389 188.216 183.167 189.723 183.167H230.484C231.991 183.167 233.214 184.389 233.214 185.895C233.217 187.401 231.994 188.623 230.484 188.623Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M231.319 272.549H171.071C170.024 272.549 169.173 271.698 169.173 270.652V266.744C169.173 265.695 170.024 264.847 171.071 264.847H231.319C232.369 264.847 233.217 265.698 233.217 266.744V270.652C233.217 271.698 232.366 272.549 231.319 272.549Z",
    fill: "#FF8578"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M255.265 286.978H178.31C177.26 286.978 176.411 286.127 176.411 285.081V279.094C176.411 278.044 177.263 277.197 178.31 277.197H255.265C256.312 277.197 257.163 278.048 257.163 279.094V285.081C257.163 286.131 256.315 286.978 255.265 286.978Z",
    fill: "#FF8578"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M230.484 298.725H189.723C188.216 298.725 186.993 297.502 186.993 295.997C186.993 294.491 188.216 293.269 189.723 293.269H230.484C231.991 293.269 233.214 294.491 233.214 295.997C233.217 297.502 231.994 298.725 230.484 298.725Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M230.484 308.44H189.723C188.216 308.44 186.993 307.218 186.993 305.712C186.993 304.207 188.216 302.984 189.723 302.984H230.484C231.991 302.984 233.214 304.207 233.214 305.712C233.217 307.218 231.994 308.44 230.484 308.44Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M230.484 198.339H189.723C188.216 198.339 186.993 197.117 186.993 195.611C186.993 194.105 188.216 192.883 189.723 192.883H230.484C231.991 192.883 233.214 194.105 233.214 195.611C233.217 197.12 231.994 198.339 230.484 198.339Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M231.319 212.631H171.071C170.024 212.631 169.173 211.78 169.173 210.734V206.823C169.173 205.773 170.024 204.926 171.071 204.926H231.319C232.369 204.926 233.217 205.777 233.217 206.823V210.731C233.217 211.78 232.366 212.631 231.319 212.631Z",
    fill: "#FF8578"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M255.265 227.06H178.31C177.26 227.06 176.411 226.209 176.411 225.163V219.175C176.411 218.126 177.263 217.279 178.31 217.279H255.265C256.315 217.279 257.163 218.129 257.163 219.175V225.163C257.163 226.212 256.315 227.06 255.265 227.06Z",
    fill: "#FF8578"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M230.484 238.806H189.723C188.216 238.806 186.993 237.584 186.993 236.078C186.993 234.572 188.216 233.35 189.723 233.35H230.484C231.991 233.35 233.214 234.572 233.214 236.078C233.217 237.584 231.994 238.806 230.484 238.806Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M230.484 248.456H189.723C188.216 248.456 186.993 247.234 186.993 245.728C186.993 244.222 188.216 243 189.723 243H230.484C231.991 243 233.214 244.222 233.214 245.728C233.217 247.234 231.994 248.456 230.484 248.456Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M230.484 258.456H189.723C188.216 258.456 186.993 257.234 186.993 255.728C186.993 254.222 188.216 253 189.723 253H230.484C231.991 253 233.214 254.222 233.214 255.728C233.217 257.234 231.994 258.456 230.484 258.456Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M249.563 403.738H90.4147C85.6164 403.738 81.7282 407.623 81.7282 412.418V440.252H258.249V412.418C258.249 407.626 254.361 403.738 249.563 403.738Z",
    fill: "url(#paint0_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M237.787 388.23H102.19C97.3919 388.23 93.5037 392.116 93.5037 396.91V403.738H246.477V396.91C246.474 392.116 242.586 388.23 237.787 388.23Z",
    fill: "url(#paint1_linear)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M210.834 388.231H129.14V346.606C129.14 344.328 130.989 342.48 133.269 342.48H206.701C208.982 342.48 210.831 344.328 210.831 346.606V388.231H210.834Z",
    fill: "url(#paint2_linear)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7693 211.588C34.7796 213.42 34.6067 216.5 36.3779 218.543L148.167 348.976C150.016 351.107 153.262 351.287 155.336 349.377L164.848 340.625L41.734 207.025L36.7693 211.588Z",
    fill: "url(#paint3_linear)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0775 169.684C48.2709 165.72 41.9917 165.525 37.9502 169.247L27.9231 178.47C23.8783 182.189 23.5554 188.46 27.1957 192.577L160.581 344.56L188.542 318.837C190.81 316.751 190.914 313.209 188.771 310.996L52.0775 169.684Z",
    fill: "url(#paint4_linear)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6448 201.53L60.5944 202.495C57.3488 205.483 57.1401 210.532 60.128 213.778L130.517 290.162C133.508 293.405 138.56 293.614 141.809 290.628L142.856 289.664C146.102 286.675 146.311 281.626 143.323 278.38L72.9375 201.993C69.9463 198.75 64.8904 198.541 61.6448 201.53Z",
    fill: "url(#paint5_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.915 368.245C190.597 368.245 206.551 352.303 206.551 332.637C206.551 312.972 190.597 297.03 170.915 297.03C151.234 297.03 135.279 312.972 135.279 332.637C135.279 352.303 151.234 368.245 170.915 368.245Z",
    fill: "#001B24"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M190.158 351.868C200.788 341.246 200.788 324.025 190.158 313.404C179.528 302.782 162.293 302.782 151.663 313.404C141.033 324.025 141.033 341.246 151.663 351.868C162.293 362.489 179.528 362.489 190.158 351.868Z",
    fill: "#022932"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2395 178.168L42.2722 185.798C43.8085 187.463 46.4148 187.531 48.0359 185.951L146.138 88.9549C147.69 87.4361 147.756 84.9623 146.284 83.362L142.615 79.3792L35.2395 178.168Z",
    fill: "url(#paint6_linear)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M148.144 49.3971L155.558 57.4409C158.549 60.6872 158.393 65.7227 155.206 68.7767L38.3938 181.593L17.7199 159.159C16.0432 157.341 16.1966 154.499 18.0558 152.869L136.809 48.8137C140.116 45.8934 145.156 46.1508 148.144 49.3971Z",
    fill: "url(#paint7_linear)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M114.315 76.661L50.1236 135.716C47.2825 138.33 47.0998 142.746 49.7159 145.585C52.3319 148.424 56.7518 148.606 59.5929 145.992L123.784 86.9374C126.625 84.3235 126.808 79.9072 124.192 77.0684C121.576 74.2295 117.152 74.047 114.315 76.661Z",
    fill: "url(#paint8_linear)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9142 199.962C46.7187 199.962 59.5308 187.161 59.5308 171.369C59.5308 155.577 46.7187 142.775 30.9142 142.775C15.1096 142.775 2.29749 155.577 2.29749 171.369C2.29749 187.161 15.1096 199.962 30.9142 199.962Z",
    fill: "url(#paint9_linear)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3674 186.811C54.9034 178.282 54.9034 164.454 46.3674 155.924C37.8314 147.395 23.9918 147.395 15.4558 155.924C6.9198 164.454 6.9198 178.282 15.4558 186.811C23.9918 195.34 37.8314 195.34 46.3674 186.811Z",
    fill: "#022932"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M235.938 97.3018L231.473 104.635C229.672 107.595 226.413 108.921 224.143 107.624L140.338 60.2993L152.789 39.8474C153.8 38.1884 155.643 37.4812 156.87 38.283L235.224 89.4209C237.422 90.8419 237.739 94.3423 235.938 97.3018Z",
    fill: "url(#paint10_linear)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M151.608 73.5613C164.013 73.5613 174.069 63.513 174.069 51.1179C174.069 38.7228 164.013 28.6746 151.608 28.6746C139.203 28.6746 129.146 38.7228 129.146 51.1179C129.146 63.513 139.203 73.5613 151.608 73.5613Z",
    fill: "url(#paint11_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M168.486 54.1523C170.161 44.8337 163.959 35.9224 154.633 34.2484C145.307 32.5744 136.388 38.7716 134.713 48.0903C133.038 57.4089 139.24 66.3202 148.566 67.9942C157.892 69.6681 166.811 63.4709 168.486 54.1523Z",
    fill: "#022932"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M247.174 92.6837L239.57 88.1011C239.234 87.8991 238.794 88.0066 238.591 88.3423L224.102 112.35C223.9 112.686 224.008 113.126 224.343 113.328L231.947 117.91C232.283 118.112 232.723 118.005 232.926 117.669L247.415 93.6615C247.617 93.3258 247.509 92.889 247.174 92.6837Z",
    fill: "url(#paint12_linear)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M257.163 101.77L275.932 88.2313L301.936 119.833L297.992 124.484L274.484 99.2834L259.959 109.909L257.163 101.77Z",
    fill: "#2A515A"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M245.215 121.759L242.322 144.705L282.544 152.354L284.739 146.667L251.334 138.134L253.699 120.306L245.215 121.759Z",
    fill: "#2A515A"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M239.154 121.16C243.013 124.321 248.405 125.406 253.422 123.552C260.95 120.768 264.793 112.415 262.007 104.893C260.598 101.086 257.76 98.2241 254.325 96.6825L239.154 121.16Z",
    fill: "url(#paint13_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M230.898 116.069L228.524 120.003C228.096 120.713 228.364 121.658 229.124 122.118L236.424 126.515C237.184 126.974 238.146 126.769 238.577 126.058L257.506 94.6943C257.933 93.9838 257.666 93.0386 256.906 92.579L249.605 88.1823C248.845 87.7227 247.883 87.9281 247.453 88.6386L245.277 92.2433L230.898 116.069Z",
    fill: "#022932"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M523.05 276.685C522.969 277.481 521.824 285.82 512.826 285.82C503.384 285.82 504.965 276.91 504.965 276.91L504.951 276.854C505.874 276.671 506.864 276.607 507.913 276.72V272.501L518.633 266.782C518.633 266.782 519.5 265.5 519.5 266C519 269.5 519.5 276.685 519.5 276.685C519.5 276.685 520.723 276.438 523.05 276.685Z",
    fill: "url(#paint14_radial)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M493.683 248.828C493.683 248.828 494.511 258.374 497.825 259.017C501.138 259.661 500.329 255.606 500.329 255.606L499.867 251.072L493.683 248.828Z",
    fill: "#002C54"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M517.849 247.942C519.371 249.414 520.516 251.315 521.07 253.633C522.097 257.964 520.784 262.606 519.469 266.776C519.247 267.487 519.334 268.149 518.869 268.747C518.536 269.177 518.115 269.529 517.694 269.881C515.788 271.466 513.882 273.051 511.976 274.635C510.683 275.713 502.749 276.608 501.235 275.572C495.398 271.593 495.329 259.782 495.443 254.168C495.443 244.401 510.565 240.899 517.849 247.942Z",
    fill: "url(#paint15_radial)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M514.754 264.81C515.818 265.113 517.62 264.338 518.079 262.93C518.537 261.514 518.485 259.901 518.485 259.901C518.485 259.901 519.024 261.183 518.743 263.24C518.463 265.296 517.709 267.254 516.017 267.282C514.326 267.304 514.754 264.81 514.754 264.81Z",
    fill: "#F7B094"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M519.755 242.912C519.659 239.316 515.844 237.964 515.844 237.964C512.049 236.262 504.151 236.998 496.011 238.736C494.104 239.141 491.706 238.028 490.376 238.911C488.768 239.978 490.367 244.852 490.367 244.852C493.507 253.929 505.056 250.977 508.533 249.855C509.362 252.191 509.256 255.437 511.308 257.12C512.483 258.077 514.515 258.104 516.596 257.773C516.856 258.233 517.809 258.647 518.002 259.281C518.657 261.406 518.561 264.726 518.542 267.283L519.524 266.823C519.649 266.124 529.783 243.206 519.755 242.912Z",
    fill: "#002C54"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M514.825 264.926C518.813 266.388 520.056 257.017 516.27 256.603C513.4 256.29 513.284 260.116 513.284 260.116C513.284 260.116 512.552 264.098 514.825 264.926Z",
    fill: "#FFC5AA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M514.736 260.631C514.817 259.687 515.829 258.659 516.849 259.272C517.905 259.905 517.654 261.575 517.218 262.497C516.878 263.216 515.726 264.012 514.95 263.336C514.3 262.772 515.312 262.11 515.341 261.596C515.371 261.131 514.403 260.8 514.802 260.307",
    fill: "#F7B094"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M507.92 275.748C512.685 275.016 515.825 271.431 515.825 271.431C515.825 271.431 514.54 277.474 507.632 277.798L507.92 275.748Z",
    fill: "#F7B094"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M515.965 362.196H522.84V428.044C522.84 428.714 522.296 429.257 521.626 429.257H517.179C516.508 429.257 515.965 428.714 515.965 428.044V362.196Z",
    fill: "#02291C"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M500.501 363.134H538.296V364.167C538.296 366.763 536.188 368.861 533.596 368.861H505.209C502.609 368.861 500.509 366.756 500.509 364.167V363.134H500.501Z",
    fill: "#022932"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M515.965 421.439H522.84V436.695C522.84 437.364 522.296 437.907 521.626 437.907H517.179C516.508 437.907 515.965 437.364 515.965 436.695V421.439Z",
    fill: "#0A2033"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M483.734 433.89C483.734 436.107 485.537 437.907 487.756 437.907C489.976 437.907 491.779 436.107 491.779 433.89C491.779 431.674 489.976 429.874 487.756 429.874C485.537 429.874 483.734 431.674 483.734 433.89Z",
    fill: "#0A2033"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M547.018 433.89C547.018 436.107 548.821 437.907 551.041 437.907C553.26 437.907 555.063 436.107 555.063 433.89C555.063 431.674 553.26 429.874 551.041 429.874C548.821 429.874 547.018 431.674 547.018 433.89Z",
    fill: "#0A2033"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M512.489 428.387H526.314V416.323H512.489V428.387Z",
    fill: "#022932"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M483.734 431.228H555.063V429.829C555.063 427.464 553.141 425.553 550.78 425.553H488.017C485.649 425.553 483.734 427.464 483.734 429.829V431.228Z",
    fill: "#FBD15B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M546.4 314.467C544.754 314.415 543.413 315.776 543.503 317.42C543.972 325.594 542.236 345.535 534.616 352.341C525.29 360.657 498.87 359.526 498.87 359.526C498.87 359.526 494.505 364.874 503.235 366.064C511.965 367.254 536.56 366.458 542.504 360.917C548.262 355.547 551.681 341.482 549.104 317.003C548.962 315.598 547.815 314.512 546.4 314.467Z",
    fill: "#02291C"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M496.896 415.251L500.039 422.406L490.408 426.623L487.257 419.446L496.896 415.251Z",
    fill: "url(#paint16_radial)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M542.296 335.732C541.7 336.922 498.922 335.754 494.885 336.126C494.885 336.126 468.703 348.607 464.941 360.285C464.561 361.46 464.457 363.014 464.569 364.874C465.619 381.319 484.375 420.703 484.375 420.703L487.257 419.446L496.896 415.251L498.267 414.656C498.267 414.656 483.392 370.393 486.364 368.013C489.336 365.633 523.056 359.697 534.75 356.536C546.46 353.36 542.296 335.732 542.296 335.732Z",
    fill: "#22253C"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M460.189 417.088L460.941 427.836H450.431L449.686 417.066L460.189 417.088Z",
    fill: "url(#paint17_radial)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M494.669 335.762L494.289 335.925C494.289 335.925 450.461 342.069 443.318 354.342C438.677 362.33 447.66 420.681 447.66 420.681L463.168 420.718C463.168 420.718 460.852 372.111 461.619 369.403C462.491 366.317 463.973 365.194 464.569 364.874C464.45 363.022 464.554 361.46 464.941 360.285C468.703 348.6 494.885 336.126 494.885 336.126C494.803 336.067 494.728 335.94 494.669 335.762Z",
    fill: "#181B32"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M536.81 295.264L533.868 295.666C533.868 295.666 533.152 303.58 531.402 311.494L494.784 325.373L494.285 328.021C494.129 328.006 493.972 327.998 493.831 327.984C493.846 328.527 493.846 329.062 493.868 329.568C493.95 332.625 494.151 334.819 494.471 335.697C494.531 335.875 494.605 336.009 494.687 336.069C495.686 336.879 508.631 335.31 522.635 340.442C534.776 344.897 541.584 349.754 541.897 349.107C545.718 341.186 538.769 310.095 536.81 295.264Z",
    fill: "#FBD15B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M533.186 313.456C532.21 318.134 529.685 327.454 524.739 328.703C518.274 330.34 505.782 330.258 494.073 329.633C494.051 329.135 494.051 328.599 494.036 328.049C494.177 328.064 494.334 328.071 494.49 328.086L494.989 325.438L531.607 311.559C533.357 303.645 534.072 295.731 534.072 295.731C534.072 295.731 534.072 295.776 534.087 295.865C534.147 297.077 534.646 306.538 533.186 313.456Z",
    fill: "#E9BF49"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M496.479 283.637C495.823 284.827 494.885 297.538 494.371 310.16L486.885 303.184C490.066 297.04 496.479 283.637 496.479 283.637Z",
    fill: "#E9BF49"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M491.995 319.383C485.678 320.477 479.868 321.414 479.868 321.414L479.853 321.726C472.822 316.118 462.118 300.231 462.118 300.231C462.118 300.231 465.321 296.393 466.118 295.381C466.237 295.225 483.682 307.215 484.576 307.111C484.799 307.089 485.693 305.519 486.885 303.191L494.371 310.168C494.252 313.173 494.155 316.17 494.095 319.012C493.395 319.131 492.695 319.25 491.995 319.383Z",
    fill: "#F7B094"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M479.868 321.414L479.712 326.621H456.448C456.448 326.621 461.084 320.854 466.239 320.854C471.393 320.854 474.863 321.912 474.863 321.912L479.868 321.414Z",
    fill: "url(#paint18_radial)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M465.976 295.262L466.118 295.381C465.321 296.393 462.118 300.231 462.118 300.231L460.129 298.825C460.129 298.825 457.939 300.157 455.392 298.766C452.74 297.33 454.379 293.894 454.513 293.485C453.999 293.626 450.818 296.2 450.319 295.924C449.82 295.649 449.448 294.749 453.008 291.246C456.554 287.743 457.757 289.457 461.53 292.243C465.302 295.028 465.976 295.262 465.976 295.262Z",
    fill: "#F7B094"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M455.809 298.171C455.809 298.171 455.042 299.606 456.405 300.231C457.768 300.856 460.42 301.302 461.559 301.198C462.699 301.094 463.608 299.494 463.608 299.494L460.159 296.259H457.396L455.809 298.171Z",
    fill: "#F7B094"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M529.745 318.305L511.093 311.708C509.738 314.237 508.285 316.141 506.848 316.52C504.672 317.093 499.406 318.075 494.103 319.004C493.403 319.138 492.695 319.257 491.995 319.384C485.678 320.477 479.868 321.414 479.868 321.414L479.853 321.727V321.927L479.712 326.621V327.811C479.712 327.811 486.043 327.491 494.028 328.049C505.201 328.845 519.615 329.321 524.389 327.074C526.624 326.018 528.411 322.545 529.819 318.268C529.789 318.275 529.767 318.29 529.745 318.305Z",
    fill: "url(#paint19_radial)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M511.093 311.708L529.745 318.305L528.896 320.789L510.438 312.883L511.093 311.708Z",
    fill: "#F7B094"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M511.093 311.708C509.738 314.237 508.285 316.141 506.847 316.52C504.672 317.093 499.406 318.075 494.103 319.004C494.162 316.163 494.259 313.173 494.378 310.161C494.892 297.538 495.831 284.827 496.486 283.637C497.559 281.651 500.486 277.337 505.105 276.355L505.119 276.415C505.119 276.415 503.525 285.824 513.045 285.824C522.11 285.824 523.264 277.017 523.354 276.177C528.017 276.697 535.175 279.025 536.158 288.39C536.359 290.242 536.65 292.622 537.015 295.314L534.072 295.716C534.072 295.716 532.881 308.904 529.827 318.26C529.804 318.275 529.782 318.283 529.752 318.298L511.093 311.708Z",
    fill: "#FBD15B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M510.9 309.99L518.348 291.99L512.859 310.718L510.9 309.99Z",
    fill: "#E9BF49"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M523.339 276.177H519.279C519.279 276.177 513.507 282.506 509.79 282.506C506.073 282.506 508.076 276.206 508.076 276.206H506.266C501.06 276.206 496.687 280.111 496.099 285.273C496.032 285.861 495.972 286.426 495.92 286.932C495.525 290.762 511.063 293.552 511.063 293.552L519.063 293.105L523.92 283.637L524.888 279.762L523.339 276.177Z",
    fill: "#FBD15B"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M474.371 434.857C474.736 436.791 476.077 438.167 478.014 437.81L503.861 432.998C504.516 432.879 504.948 432.247 504.821 431.592L504.397 429.301C504.397 429.301 477.209 434.054 474.356 434.843L474.371 434.857Z",
    fill: "#F1F2F2"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M482.056 428.357C482.324 428.126 482.585 427.888 482.853 427.658C483.375 427.196 483.881 426.743 484.373 426.304C484.634 426.073 484.894 425.843 485.133 425.62C485.602 425.196 486.049 424.801 486.451 424.444C486.734 424.184 487.002 423.939 487.248 423.723C487.688 423.329 488.053 423.001 488.306 422.778C488.522 422.585 488.85 422.57 489.073 422.763C490.138 423.656 493.572 425.694 499.792 421.848C500.09 421.663 500.477 421.759 500.641 422.072L504.402 429.294C504.402 429.294 477.215 434.047 474.362 434.835C475.293 434.255 478.764 431.257 482.056 428.357Z",
    fill: "#181B32"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M433.664 434.605C433.709 436.576 434.819 438.145 436.793 438.1L463.079 437.461C463.742 437.446 464.271 436.895 464.256 436.226L464.196 433.898C464.196 433.898 436.599 434.262 433.657 434.59L433.664 434.605Z",
    fill: "#F1F2F2"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M442.29 429.413C442.595 429.227 442.886 429.041 443.191 428.848C443.779 428.476 444.353 428.111 444.904 427.754C445.195 427.568 445.493 427.382 445.761 427.204C446.297 426.862 446.796 426.542 447.243 426.252C447.571 426.043 447.869 425.843 448.144 425.664C448.643 425.344 449.053 425.084 449.336 424.898C449.582 424.742 449.902 424.779 450.096 425.002C451.005 426.051 454.066 428.61 460.822 425.805C461.142 425.672 461.515 425.828 461.619 426.155L464.181 433.883C464.181 433.883 436.584 434.247 433.642 434.575C434.67 434.158 438.573 431.748 442.29 429.413Z",
    fill: "#181B32"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M414.96 327.811L402.449 294.482C401.713 292.521 403.163 290.428 405.258 290.428H440.889L454.93 327.811H414.96Z",
    fill: "#ABB5BA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M457.396 327.811H454.93L440.889 290.428C442.251 290.486 443.447 291.347 443.936 292.62L456.122 324.367L457.396 327.811Z",
    fill: "#8495A0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M456.621 327.811H483.027L482.952 325.453C482.952 325.453 456.517 325.453 456.077 325.453",
    fill: "#8495A0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M569.133 334.944H562.772V439.246H569.133V334.944Z",
    fill: "#8495A0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M534.624 334.944H528.263V439.246H534.624V334.944Z",
    fill: "#ABB5BA"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M424.055 334.944H417.694V439.246H424.055V334.944Z",
    fill: "#8495A0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M389.546 334.944H383.184V439.246H389.546V334.944Z",
    fill: "#ABB5BA"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M575.495 335.338H377.091C375.386 335.338 374 333.954 374 332.251V330.897C374 329.194 375.386 327.811 377.091 327.811H575.495C577.2 327.811 578.586 329.194 578.586 330.897V332.251C578.586 333.954 577.2 335.338 575.495 335.338Z",
    fill: "#181B32"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M407.601 294.355L408.279 296.177H416.242L415.556 294.355H407.601Z",
    fill: "#8495A0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M486.885 303.184L486.319 304.292L494.371 312.6V310.161L486.885 303.184Z",
    fill: "#E8987C"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 439H61.5C59.0147 439 57 441.015 57 443.5C57 445.985 59.0147 448 61.5 448H602.5C604.985 448 607 445.985 607 443.5C607 441.015 604.985 439 602.5 439Z",
    fill: "#181B32"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 115.279,
    y: 287.03,
    width: 111.273,
    height: 111.215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 172.024,
    y1: 382.059,
    x2: 169.144,
    y2: 444.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 171.651,
    y1: 365.046,
    x2: 169.183,
    y2: 417.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 328.049,
    y1: 248.579,
    x2: 248.505,
    y2: 307.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 90.0981,
    y1: 285.964,
    x2: 103.281,
    y2: 273.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 88.7342,
    y1: 266.59,
    x2: 120.707,
    y2: 237.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 65.4839,
    y1: 163.69,
    x2: 115.236,
    y2: 276.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 109.856,
    y1: 158.482,
    x2: 90.071,
    y2: 129.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 26.5656,
    y1: 168.755,
    x2: 151.794,
    y2: 53.3571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 68.524,
    y1: 82.9143,
    x2: 101.536,
    y2: 133.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 9.86209,
    y1: 190.738,
    x2: 51.9336,
    y2: 151.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 147.462,
    y1: 48.5987,
    x2: 233.646,
    y2: 101.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 196.689,
    y1: 41.3757,
    x2: 97.8433,
    y2: 62.7709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 259.358,
    y1: 96.4917,
    x2: 206.701,
    y2: 105.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 274.879,
    y1: 104.542,
    x2: 221.96,
    y2: 114.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A515A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.96 276.3) scale(9.54891 9.1037)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB9C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(508.435 259.822) rotate(-11.6007) scale(15.0239 14.3814)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB9C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(493.647 420.936) scale(6.05275 6.04398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB9C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(455.313 422.452) scale(5.51315 5.50517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB9C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(488.878 319.148) scale(30.8705 30.8259)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB9C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(488.878 319.148) scale(30.8704 30.8258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB9C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitecture);
export default __webpack_public_path__ + "static/media/architecture.53da9e28.svg";
export { ForwardRef as ReactComponent };